import React, {Component} from 'react';
import {bindActionCreators} from 'redux';
import {connect} from 'react-redux';
import actionCreators from 'actions/creators';
import classNames from "classnames";
import CupoyRouter from "components/commons/router/CupoyRouter";

class AddEmptyInvoiceView extends Component {

    constructor(props) {
        super(props);

        this.handleSubmit = this
            .handleSubmit
            .bind(this);

        this.state = {
            upldfile: '',
            comment: '',
            isLoading: false,
            isError: false,
            isNoFile: false,
            isRepeatError: false,
            isWrongCRNError : false,
        }
    }

    onInputChange(fieldname, event) {
        this.setState({[fieldname]: event.target.value})
    }

    onInputFileChange(fieldname, event) {
        this.setState({[fieldname]: event.target.files[0]})
    }

    handleSubmit(event) {
        event.preventDefault();

        if (this.state.isLoading) {
            return;
        }

        this.setState({
            isLoading: true,
            isError: false,
            isNoFile: false,
            isRepeatError: false,
            isWrongCRNError:false,
        }, () => {
            if(!this.state.upldfile) {
                this.setState({
                    isLoading: false,
                    isNoFile: true,
                });
                return;
            }

            this.props.emptyInvoiceActions.addEmptyInvoice({
                upldfile: this.state.upldfile,
                comment: this.state.comment,
            }).then((result) => {

                if (result) {
                    this.props.emptyInvoiceActions.getEmptyInvoiceYearmonthList();
                    this.props.webActions.cupoyStateGo(CupoyRouter.STATES.EMPTYINVOICE_LIST, {page: 1});
                } else {
                    this.setState({
                        isError: true,
                        isLoading: false
                    });
                }

            }, (error) => {

                if (error && error.code === 'error.formValidator.EmptyInvoiceidRepeatFailed') {
                    this.setState({
                        isLoading: false,
                        isError: false,
                        isRepeatError: true,
                    });
                } if (error && error.code === 'error.jcolorWrongCRNEInvoiceError') {
                    this.setState({
                        isLoading: false,
                        isError: false,
                        isWrongCRNError: true,
                    });

                } else {
                    this.setState({
                        isError: true,
                        isLoading: false
                    });
                }
            });
        });
    }

    render() {

        return (
            <div id="add-empty-invoice">
                <div className="header-bar mix">
                    <h1 className="title">上架空白發票</h1>
                    <div className="button-group">
                        {this.state.isRepeatError ?
                            <span className="error">上傳了重複的空白發票</span>
                            :
                            null
                        }
                        {this.state.isWrongCRNError ?
                            <span className="error">上傳了非本公司的空白發票</span>
                            :
                            null
                        }

                        {this.state.isError ?
                            <span className="error">發生無法處理的錯誤，請聯絡工程師</span>
                            :
                            null
                        }
                        <a className="button blue" onClick={this.handleSubmit}>
                            {this.state.isLoading ? 
                                <i className="zmdi zmdi-spinner animate-spinner"></i>
                                :
                                null
                            }
                            確定上架
                        </a>
                    </div>
                </div>
                <div className="scroll-content">
                    <div className="form">
                        <div className="block-form none-box-shadow">
                            <div className="block-form-row">
                                <div 
                                    className={classNames("block-form-col", {
                                       'error': this.state.isNoFile
                                    })}
                                >
                                    <h5 className="title">上傳電子發票專用字軌配號檔(.csv)</h5>
                                    <div className="description">
                                        <label className="button gray button-outline upload">
                                            <input
                                                type="file"
                                                accept="text/csv"
                                                multiple={false}
                                                onChange={(event) => this.onInputFileChange('upldfile', event)}/>
                                            選擇檔案
                                        </label>
                                        {this.state.upldfile ?
                                            <span>{this.state.upldfile.name}</span>
                                            :
                                            <span>尚未選擇任何檔案</span>    
                                        }
                                    </div>
                                </div>
                            </div>
                            <div className="block-form-row">
                                <label className="block-form-col">
                                    <h5 className="title">備註</h5>
                                    <textarea
                                        type="text"
                                        value={this.state.comment}
                                        onChange={(event) => this.onInputChange('comment', event)}
                                        style={{height: '100px'}}
                                    />
                                </label>
                            </div>
                        </div>        
                    </div>
                </div>
            </div>
        );
    }
}

const mapStateToProps = function(state) {
    return {
    };
};

const mapActionToProps = function (dispatch) {
    return {
        emptyInvoiceActions: bindActionCreators(actionCreators.emptyInvoiceActionCreators, dispatch),
        webActions: bindActionCreators(actionCreators.webActionCreators, dispatch)
    };
};

export default connect(mapStateToProps, mapActionToProps, null, {withRef: true})(AddEmptyInvoiceView);


// WEBPACK FOOTER //
// ./src/components/emptyInvoice/AddEmptyInvoiceView.jsx